import { useMutation, useQuery } from "@tanstack/react-query";
import { Col, Form, message, Row } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ServicePartnerTagFormCard } from "./components/ServicePartnerTagFormCard";
import { ServicePartnerTagFormData } from "@rumble-it/common-lib/types/models/ServicePartnerTag.interface";
import {
  fetchServicePartnerTagById,
  updateServicePartnerTagById,
} from "@/lib/api/resources/servicePartnerTags.ts";

export const ServicePartnerTagEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm<ServicePartnerTagFormData>();

  if (!id) return null;

  const servicePartnerTagQuery = useQuery({
    queryKey: ["service-partner-tags", id],
    queryFn: () => fetchServicePartnerTagById(id),
  });

  const updateServicePartnerTagMutation = useMutation({
    mutationFn: (data: ServicePartnerTagFormData) =>
      updateServicePartnerTagById(id, data),
    onSuccess: () => {
      navigate(`/service-partners/tags/${id}`);
      message.success("Tag succesvol bijgewerkt");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het bijwerken van de tag"),
  });

  useEffect(() => {
    if (servicePartnerTagQuery.data) {
      form.setFieldsValue({
        name: servicePartnerTagQuery.data.name,
      });
    }
  }, [form, servicePartnerTagQuery.data]);

  const handleFinish = (values: ServicePartnerTagFormData) => {
    updateServicePartnerTagMutation.mutate(values);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerTagFormCard
            title="Tag bewerken"
            buttonText="Bewerken"
            isLoading={servicePartnerTagQuery.isLoading}
            submitting={updateServicePartnerTagMutation.isPending}
          />
        </Col>
      </Row>
    </Form>
  );
};
